import logo from '@/assets/bulkpe_logo_black_200.png'
import bagroung from '@/assets/bagroung.jpg'
export const CONFIGS = {
    apiBase: "https://salesapi.bulkpe.in",
    cId: "712696612499-44556bbt0tggqf6jblnph8oblu99nkb7.apps.googleusercontent.com",
    cKey: "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",
}

export const IMAGES = {
    logo: logo,
    bagroung: bagroung,
}

export const Strg = {
    tkes: "ADFR"
}